<template>
    <div class="name">
      <h1>{{ data.name }}</h1>
      <span class="title">{{ data.title }}</span>
    </div>
</template>

<script>
    import data from '../../assets/data'

    export default {
      name: 'Name',
      data: () => {
        return {
          data
        }
      },      
      props: {
        msg: String
      }
    }
    
</script>

<style scoped>
</style>

